<template>
  <div class="table-wrapper">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="table-row"
      @click="goToDetail(index)"
    >
      <div class="table-cell">
        <span class="fontS">{{
          totalDataCount + 1 - ((activePage - 1) * pageDataCount + index + 1)
        }}</span>
      </div>
      <div v-for="(value, key) in item" :key="key" class="table-cell">
        <span class="fontS">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array, // 테이블 데이터
    activePage: Number, // 현재 페이지
    totalDataCount: Number, // 전체 데이터 개수
    pageDataCount: Number, // 한 페이지 데이터 개수
    dataKey: String,
  },
  data() {
    return {
      data: [],
      category: {
        notice: "공지",
        article: "기사",
        video: "영상",
      },
    };
  },
  methods: {
    goToDetail(index) {
      if (localStorage.loginUser === "springsoft") {
        this.$router.push({
          name: "newsDetail",
          params: {item: this.tableData[index]},
          query: {id: this.tableData[index]["Key"]},
        });
        return;
      }

      if (this.data[index].Category === "공지") {
        this.$router.push({
          name: "newsDetail",
          params: {item: this.tableData[index]},
          query: {id: this.tableData[index]["Key"]},
        });
      } else {
        window.open(this.tableData[index].Content);
      }
    },
    setTableData() {
      let data = JSON.parse(JSON.stringify(this.tableData));
      data.forEach((element) => {
        element.Category = this.category[element.Category];
        delete element.Key;
        delete element.IsValid;
        delete element.Content;
      });
      this.data = data;
    },
  },
  mounted() {
    this.setTableData();
  },
  watch: {
    tableData() {
      this.setTableData();
    },
  },
};
</script>

<style scoped>
.table-row {
  display: table-row;
}
.table-cell {
  display: table-cell;
  cursor: pointer;
  padding: 1rem;
  border-bottom: 1px solid lightgrey;
  color: grey;
}
</style>
